import React, { useState } from "react";
import { connect } from 'react-redux';
import { apiRequest, ajaxWatched } from '../../shared/services';
import {userLogOut} from "../../shared/actions/user";
import DataGrid from 'react-data-grid';
import './d5.css';

const logOut = () => dispatch => {
    dispatch(userLogOut());
    return Promise.resolve();
}


export function fetchSearchResults(searchText, callback) {
    let resource = '/v2/api/extensions/d5/search';
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, resource, {
                method: 'POST',
                body: JSON.stringify({
                    searchText: searchText
                })
            }).then(callback)
        ))
    }
}

export function removeRespondent(recordId, respondentEmail, callback) {
    let resource = '/v2/api/extensions/d5/remove-respondent';
    return (dispatch, getState) => {
        dispatch(ajaxWatched(
            apiRequest(dispatch, getState, resource, {
                method: 'POST',
                body: JSON.stringify({
                    recordId: recordId,
                    respondentEmail: respondentEmail
                })
            }).then(callback)
        ))
    }
}

const RespondentTile = (props) => {
    const r = props.respondent;
    return (
        <div className="ac-tile">
            <h2>{r['d8c7070b-44ca-4e7a-95e3-0252037a6136']}</h2>
            <label>Contact's Name</label>
            <p>{r['edb4efa4-de38-43aa-ad2d-89ba65c08d93']}</p>
            <label>Email address on contact:</label>
            <p>{r['54d2e311-ac95-4b97-904a-5f473c90db11']}</p>
            <label>Company's marketing contact:</label>
            <p>{r['f6d76a40-a200-4d0f-abb1-70ead48ca6bd']} &lt;{r['bf7148f6-b802-4247-9e5e-2e10d5545f5c']}&gt;</p>
            <hr/>
            <label>Managed by:</label>
            <p>{r['_email']}</p>
            <button onClick={(e) => props.onRemoveClicked(r)}>Remove Respondent</button>
        </div>
    );
}

const SearchFormD5 = (props) => {
    const [searchText, setSearchText] = useState(undefined);
    const [results, setResults] = useState(undefined);

    function handleLogOut() {
        props.dispatch(logOut()).then(() => window.location.reload(false));
    }

    const executeSearch = (e) => {
        e.preventDefault();
        props.dispatch(fetchSearchResults(searchText, json => {
            console.log(json);
            setResults(json);
        }))
    }

    let resultsLabel = "Results";
    if (results) {
        resultsLabel = `${results.respondents.length} respondents found`;
    }

    const handleRespondentRemoveClicked = (r) => {
        //alert(r['_id'] + ': ' + r['_email']);
        props.dispatch(removeRespondent(r['_id'], r['_email'], json => {
            if (!json.succeeded){
                alert('Failed to update.');
            }
            props.dispatch(fetchSearchResults(searchText, j => {
                setResults(j);
            }))
        }))
    }
    
    let respondents = (results && results.respondents) ?
        results.respondents.map(r => <RespondentTile
            respondent={r}
            key={r['_id']+r['_email']}
            onRemoveClicked={handleRespondentRemoveClicked}
        />) :
        (<></>);


    return (
        <div className="ac-container">
            <div className="ac-row">
                <h2>501D5-D5A Vendor Database</h2>
                <a className="push-right" href="#" onClick={(e) => {handleLogOut(); return false;}}>Log Out</a>
            </div>
            <div className="ac-row">
                <form onSubmit={executeSearch}>
                    <input type="text" name="searchText" id="searchText"
                           onBlur={e => setSearchText(e.target.value)}
                           defaultValue={searchText}
                           placeholder="Name, email, company name..."
                    />
                    <input type="submit" value="Search" />
                </form>
            </div>
            <div className="ac-row">
                <h3>{resultsLabel}</h3>
            </div>
            <div className="ac-row">
                <div className="ac-tiles">{respondents}</div>
            </div>
        </div>
    );
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(SearchFormD5);